import axiosInstance from '../../../helpers/api';

export const getAllStudentChapters = (body) => {
    return axiosInstance.get('/students/chapters', body);
};

export const getAllChapters = (body) => {
    return axiosInstance.get('/students/chapters/all', body);
};


export const getStudentChapters = (body) => {
    return axiosInstance.get('/students/chapters/active', body);
};

export const getChapterContent = (chapter_id) => {
    return axiosInstance.get(`/students/chapters/content/${chapter_id}`);
};